var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: { actions: _vm.pageActionConfig, page: _vm.pageConfig }
      }),
      _vm.showCardConsultation
        ? _c("add-consultation", {
            attrs: { title: "Añadir Consulta" },
            on: {
              "on-close": function($event) {
                _vm.showCardConsultation = false
              }
            }
          })
        : _vm._e(),
      _vm.showRequest
        ? _c("request-reinbursement", {
            attrs: {
              filter: _vm.filterModel,
              "request-type": _vm.disbursementRequestType
            },
            on: {
              "on-cancel": function($event) {
                _vm.disbursementRequestType = 0
              }
            }
          })
        : _vm._e(),
      _vm.showFilterManager
        ? _c("filter-manager", {
            ref: "filterRef",
            staticClass: "mb-4",
            attrs: {
              filters: _vm.filtersConfig,
              "open-advanced": _vm.showAdvanced
            },
            on: {
              academicYear: _vm.onChangeAcademicYearHandler,
              center: _vm.onChangeCenterHandler,
              determination: _vm.onChangeDeterminationHandler,
              isOneTimePayment: _vm.onChangeIsOneTimePaymentHandler,
              month: _vm.onChangeMonthHandler,
              municipality: _vm.onChangeMunicipalityHandler,
              requestStatus: _vm.onChangeRequestStatusHandler,
              school: _vm.onChangeSchoolHandler,
              search: _vm.onSearchHandler
            },
            model: {
              value: _vm.filterModel,
              callback: function($$v) {
                _vm.filterModel = $$v
              },
              expression: "filterModel"
            }
          })
        : _vm._e(),
      _vm.showProcessDirectPayment
        ? _c(
            "div",
            { staticClass: "payment-process-section" },
            [
              _c("payment-process", {
                attrs: {
                  "academic-year-id": _vm.filterModel.academicYear.id,
                  items: _vm.checkedRows,
                  month: _vm.filterModel.month.id,
                  year: _vm.filterModel.academicYear.year
                },
                on: {
                  cancel: _vm.cancelPaymentProcess,
                  saved: _vm.savedPaymentProcess
                }
              }),
              _c("check-box", {
                staticClass: "d-flex justify-content-end mt-4 pr-2",
                class: [{ checked: _vm.allRowsChecked }],
                attrs: { text: "Seleccionar todo", value: _vm.allRowsChecked },
                on: { input: _vm.onCheckAllRowsHandler }
              })
            ],
            1
          )
        : _vm._e(),
      _c("custom-separator", {
        staticClass: "my-4",
        attrs: { text: "Resultados" }
      }),
      _vm.results.length == 0
        ? _c("custom-result-not-found", {
            attrs: { text: "No hay información disponible." }
          })
        : _vm._e(),
      _vm._l(_vm.results, function(row) {
        return _c(
          "div",
          { key: row.id },
          [
            _c("result-row", {
              attrs: { checkable: _vm.showProcessDirectPayment, data: row }
            })
          ],
          1
        )
      }),
      _vm.showPagination
        ? _c("pagination", {
            attrs: { data: _vm.pagination, "show-text": "" },
            on: { "pagination-go-page": _vm.goToPageHandler }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }